<template>
  <v-card elevation="0" flat tile>
    <v-card-text>
      <v-row justify="space-around">
        <v-col cols="12" md="5">
          <!-- ICCID Data -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.iccidData"
            :label="$t('display/elevator:edit.labels.hardware-tab.iccid-data')"
          />

          <!-- Phone no. data connection -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.dataPhoneNumber"
            :label="$t('display/elevator:edit.labels.hardware-tab.data-phone-number')"
          />

          <!-- ICCID Emergency -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.iccidEmergency"
            :label="$t('display/elevator:edit.labels.hardware-tab.iccid-emergency')"
          />

          <!-- Phone no. emergency calls -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.emergencyPhoneNumber"
            :label="$t('display/elevator:edit.labels.hardware-tab.emergency-phone-number')"
          />

          <!-- SN Tablet -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.serialnumberTablet"
            :label="$t('display/elevator:edit.labels.hardware-tab.serialnumber-tablet')"
          />

          <!-- SN Blackbox -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.serialnumberBlackbox"
            :label="$t('display/elevator:edit.labels.hardware-tab.serialnumber-blackbox')"
          />

          <!-- SN Camera -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.serialnumberButtonModule"
            :label="$t('display/elevator:edit.labels.hardware-tab.serialnumber-button-module')"
          />

          <!-- SN Computer -->
          <v-text-field
              outlined
              v-model="$store.state.display.elevatorForm.elevator.serialnumberComputer"
              :label="$t('display/elevator:edit.labels.hardware-tab.serialnumber-computer')"
          />
        </v-col>
        <v-col cols="12" md="5">
          <!-- MAC -->
          <v-text-field
            outlined
            disabled
            v-model="$store.state.display.elevatorForm.elevator.mac"
            :label="$t('display/elevator:edit.labels.hardware-tab.mac')"
          />

          <!-- OS -->
          <v-text-field
            outlined
            disabled
            v-model="$store.state.display.elevatorForm.elevator.operatingSystem"
            :label="$t('display/elevator:edit.labels.hardware-tab.os')"
          />

          <!-- Device ID -->
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.deviceId"
            :label="$t('display/elevator:edit.labels.hardware-tab.device-id')"
          />

          <!-- PC-Visit Data -->
          <h4 class="primary--text font-weight-medium">
            {{ $t('display/elevator:edit.titles.hardware-tab.pc-visit-data') }}
          </h4>
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.remoteNumber"
            :label="$t('display/elevator:edit.labels.hardware-tab.remote-number')"
          />
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.pcvisit"
            :label="$t('display/elevator:edit.labels.hardware-tab.pc-visit-name')"
          />

          <!-- Technician info -->
          <h4 class="primary--text font-weight-medium">
            {{ $t('display/elevator:edit.titles.hardware-tab.technician-info') }}
          </h4>
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.technicianName"
            :label="$t('display/elevator:edit.labels.hardware-tab.technician-name')"
          />
          <v-text-field
            outlined
            v-model="$store.state.display.elevatorForm.elevator.technicianPhone"
            :label="$t('display/elevator:edit.labels.hardware-tab.technician-phone')"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

</template>

<script>
import {ruleRequired} from '@/modules/core/services/rules';

export default {
  name: "HardwareTab",
  methods: {
    ruleRequired
  }
}
</script>

<style scoped>

</style>